<template>
  <el-row>
    <el-col
      :xs="{ span: 22, offset: 1 }"
      :sm="{ span: 22, offset: 1 }"
      :md="{ span: 20, offset: 2 }"
      :lg="{ span: 16, offset: 4 }"
      :xl="{ span: 16, offset: 4 }"
    >
      <el-card class="box-card">
        <!-- 题目 -->
        <h3 class="head-title">
          {{ $t("myProjects.title") }}
          <span style="font-size: 20px; padding-left: 30px">
            <span @click="dialogVisible = true"
              ><u>{{ $t("myProjects.title_delete") }}</u></span
            >
          </span>
        </h3>
        <!-- <div class="panel-body" v-if='project_list.length'> -->
        <div class="panel-body">
          <!-- 按钮 -->
          <div class="button-group">
            <span @click="$router.push('/project/setting')">
              <button-primary class="btn1">
                <i class="el-icon-circle-plus-outline"></i>
                {{ $t("myProjects.add") }}
              </button-primary>
            </span>
            <span @click="batchDelete">
              <button-secondary class="btn2">
                <i class="el-icon-circle-close"></i> {{ $t("myProjects.del") }}
              </button-secondary>
            </span>
            <span @click="toggleAllExpansion">
              <button-secondary class="btn2">
                {{ $t("myProjects.Expanded") }}
              </button-secondary>
            </span>
          </div>
          <el-alert
            :title="$t('myProjects.tip')"
            type="warning"
            show-icon
            :closable="false"
          >
          </el-alert>
          <!-- 表格 -->
          <el-table
            :data="project_list"
            border
            style="width: 100%"
            class="project-table"
            @selection-change="handleSelectionChange"
            @row-click="checkDetail"
            ref="projectTable"
            :row-key="rowKey"
            :row-class-name="tableRowClassName"
            :indent="16"
          >
            <el-table-column
              align="center"
              type="selection"
              width="60"
              :reserve-selection="true"
            ></el-table-column>

            <el-table-column
              prop="relationType"
              :label="$t('myProjects.type')"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span :class="scope.row.relationType == 'use' ? 'color1' : 'color2'">{{
                  scope.row.relationType == "use" ? "手动设置" : "智能算法"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="projectName"
              :label="$t('myProjects.proName')"
              width="230"
            ></el-table-column>
            <el-table-column
              prop="description"
              :label="$t('myProjects.proDesc')"
            ></el-table-column>
            <el-table-column
              prop="createDate"
              :label="$t('myProjects.time')"
              :formatter="resolvingDate"
            ></el-table-column>
            <el-table-column
              prop="editDate"
              :label="$t('myProjects.updateTime')"
              :formatter="resolvingUpDate"
            ></el-table-column>
            <el-table-column
              prop="cfaRate"
              :label="$t('myProjects.cfaprogress')"
              :formatter="resolvingCfaRate"
            ></el-table-column>
            <el-table-column
              prop="fullRate"
              :label="$t('myProjects.fullprogress')"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <el-progress
                  v-if="scope.row.fullRate != -1"
                  :text-inside="true"
                  :stroke-width="26"
                  :percentage="scope.row.fullRate"
                  color="#337ab7"
                ></el-progress>
                <span v-else style="color: red">{{ $t("detail.err5") }}</span> -->
                <el-tag :type="getModelProgress(scope.row.fullRate).type">{{
                  getModelProgress(scope.row.fullRate).text
                }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <p v-if="total != 0">
            {{ $t("myProjects.count1") }}{{ from }}{{ $t("myProjects.count2") }}{{ to
            }}{{ $t("myProjects.count3") }}{{ total }}{{ $t("myProjects.count4") }}
          </p>
          <div style="text-align: right" v-if="total != 0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 25]"
              :page-size="pageSize"
              layout="sizes, prev, pager, next"
              :total="total"
              style="margin: 0 auto"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-dialog
      :title="$t('myProjects.title_delete')"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div class="panel-body">
        <!-- 按钮 -->
        <div class="button-group">
          <span @click="batchRecover">
            <button-primary class="btn1">
              <i class="el-icon-circle-plus-outline"></i>
              {{ $t("myProjects.recover") }}
            </button-primary>
          </span>
          <span @click="batchDelete_1">
            <button-secondary class="btn2">
              <i class="el-icon-circle-close"></i> {{ $t("myProjects.del") }}
            </button-secondary>
          </span>
        </div>
        <!-- 表格 -->
        <el-table
          :data="projects_deleted.project_list"
          border
          style="width: 100%"
          class="project-table"
          @selection-change="handleSelectionChange_deleted"
          ref="projectTable_deleted"
          :row-key="rowKey_deleted"
        >
          <el-table-column
            align="center"
            type="selection"
            width="60"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column
            prop="projectName"
            :label="$t('myProjects.proName')"
            width="230"
          ></el-table-column>
          <el-table-column
            prop="description"
            :label="$t('myProjects.proDesc')"
          ></el-table-column>
          <el-table-column
            prop="createDate"
            :label="$t('myProjects.time')"
            :formatter="resolvingDate"
          ></el-table-column>
          <el-table-column
            prop="cfaRate"
            :label="$t('myProjects.opt')"
            :formatter="resolvingCfaRate"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleRecove(scope.row.projectId)"
                type="primary"
                style="line-height: 0.5"
                >{{ $t("myProjects.recover") }}</el-button
              >
              <el-button
                @click="handleDelete_1(scope.row.projectId)"
                type="danger"
                style="line-height: 0.5; margin-left: 10px"
                >{{ $t("myProjects.del") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <p v-if="projects_deleted.total != 0">
          {{ $t("myProjects.count1") }}{{ from_deleted }}{{ $t("myProjects.count2")
          }}{{ to_deleted }}{{ $t("myProjects.count3") }}{{ projects_deleted.total
          }}{{ $t("myProjects.count4") }}
        </p>
        <div style="text-align: right" v-if="projects_deleted.total != 0">
          <el-pagination
            @size-change="handleSizeChange_deleted"
            @current-change="handleCurrentChange_deleted"
            :current-page.sync="projects_deleted.currentPage"
            :page-sizes="[5, 10]"
            :page-size="projects_deleted.pageSize"
            layout="sizes, prev, pager, next"
            :total="projects_deleted.total"
            style="margin: 0 auto"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import {
  getProjectList,
  batchDeleteProject,
  batchDeleteProject_1,
} from "network/project";
import MainBody from "components/body/MainBody";
import ButtonPrimary from "components/body/ButtonPrimary";
import ButtonSecondary from "components/body/ButtonSecondary";
export default {
  name: "Project",
  components: {
    MainBody,
    ButtonPrimary,
    ButtonSecondary,
  },
  data() {
    return {
      isExpanded: false,
      project_list: [],
      userId: 0,
      currentPage: 1, //当前页
      pageSize: 10, //页大小
      total: 0,
      processListener: null,
      tableChecked: [],
      dialogVisible: false,
      projects_deleted: {
        project_list: [],
        currentPage: 1, //当前页
        pageSize: 5, //页大小
        total: 0,
        tableChecked: [],
        processListener: null,
      },
    };
  },
  async created() {
    //获取项目列表
    this.userId = this.$store.getters.id;
    await this.getProjects();

    // const runningProject = this.project_list.filter(item => item.projectStatus === 1)
    // if (runningProject && runningProject.length > 0) {
    this.processListener = setInterval(() => {
      this.getProjects();
    }, 2000);
    // }
    await this.getProjects_deleted();
    // runningProject = this.projects_deleted.project_list.filter(item => item.projectStatus === 1)
    // if (runningProject && runningProject.length > 0) {
    this.projects_deleted.processListener = setInterval(() => {
      this.getProjects_deleted();
    }, 2000);
  },
  computed: {
    from() {
      return this.pageSize * (this.currentPage - 1) + 1;
    },
    to() {
      return this.pageSize * this.currentPage > this.total
        ? this.total
        : this.pageSize * this.currentPage;
    },
    from_deleted() {
      return this.projects_deleted.pageSize * (this.projects_deleted.currentPage - 1) + 1;
    },
    to_deleted() {
      return this.projects_deleted.pageSize * this.projects_deleted.currentPage >
        this.projects_deleted.total
        ? this.projects_deleted.total
        : this.projects_deleted.pageSize * this.projects_deleted.currentPage;
    },
  },
  methods: {
    async getProjects(deleted_status = 0) {
      try {
        const res = await getProjectList(
          this.userId,
          this.currentPage,
          this.pageSize,
          deleted_status
        );
        this.project_list = res.data.data === null ? [] : res.data.data;
        this.total = res.data.total;
        // if (this.project_list && this.project_list.length > 0) {
        //   const projectStatusList = this.project_list.filter(item => (item.projectStatus === 1 || item.fullRate === 0))
        //   if (projectStatusList && projectStatusList.length === 0 && this.processListener) {
        //     clearInterval(this.processListener)
        //     this.processListener = null
        //   }
        // }
      } catch (err) {
        // if(this.processListener) clearInterval(this.processListener)
        this.$message.error(this.$t("myProjects.prompt"));
      }
    },
    async getProjects_deleted(deleted_status = 1) {
      try {
        const res = await getProjectList(
          this.userId,
          this.currentPage,
          this.pageSize,
          deleted_status
        );
        this.projects_deleted.project_list = res.data.data === null ? [] : res.data.data;
        this.projects_deleted.total = res.data.total;
        // if (this.projects_deleted.project_list && this.projects_deleted.project_list.length > 0) {
        //   const projectStatusList = this.projects_deleted.project_list.filter(item => (item.projectStatus === 1 || item.fullRate === 0))
        //   if (projectStatusList && projectStatusList.length === 0 && this.projects_deleted.processListener) {
        //     clearInterval(this.projects_deleted.processListener)
        //     this.projects_deleted.processListener = null
        //   }
        // }
      } catch (err) {
        // if(this.projects_deleted.processListener) clearInterval(this.projects_deleted.processListener)
        this.$message.error(this.$t("myProjects.prompt"));
      }
    },
    rowKey(row) {
      return row.projectId;
    },
    rowKey_deleted(row) {
      return row.projectId;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getProjects();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getProjects();
    },
    handleSizeChange_deleted(val) {
      this.projects_deleted.pageSize = val;
      this.projects_deleted.currentPage = 1;
      this.getProjects_deleted();
    },
    handleCurrentChange_deleted(val) {
      this.projects_deleted.currentPage = val;
      this.getProjects_deleted();
    },
    //时间戳转时间
    resolvingDate(row, column) {
      //date是传入的时间
      let d = new Date(row.createDate);
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day;

      return times;
    },
    //时间戳转时间
    resolvingUpDate(row, column) {
      //date是传入的时间
      let d = new Date(row.editDate);
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day;

      return times;
    },

    //可视化进度
    resolvingCfaRate(row, column) {
      if (row.cfaRate !== 100) return this.$t("myProjects.notfinish");
      else return this.$t("myProjects.finish");
    },
    //删除项目
    handleSelectionChange(val) {
      this.tableChecked = val;
      // console.log(val);
    }, //得到选中的数据
    handleSelectionChange_deleted(val) {
      this.projects_deleted.tableChecked = val;
    },
    // 批量删除项目
    batchDelete() {
      var that = this;
      var val = this.tableChecked;
      if (val.length == 0) {
        this.$message.warning(this.$t("myProjects.delTopic"));
      } else {
        this.$confirm("确定要删除选择的项目?").then((res) => {
          if (val) {
            const projectIdList = val.map((item) => item.projectId);
            if (projectIdList) {
              batchDeleteProject(projectIdList, 1).then(async (res) => {
                if (res.data.code === 200) {
                  this.$message.success(this.$t("myProjects.delSuccessMsg"));
                  await this.getProjects();
                } else {
                  this.$message.error(this.$t("myProjects.delSuccessMsg"));
                }
              });
              that.$refs.projectTable.clearSelection();
            }
            // console.log('选中的项目id列表：', projectIdList)
            // val.forEach((item, index) => {
            //   that.project_list.forEach((itemI, indexI) => {
            //     if (item === itemI) {
            //       that.project_list.splice(indexI, 1);
            //       batchDeleteProject(itemI.projectId);
            //     }
            //   });
            // });
          }
        });
      }
      // this.$refs.projectTable.clearSelection();
      // this.getProjects();
    },
    batchRecover() {
      var that = this;
      var val = this.projects_deleted.tableChecked;
      if (val.length == 0) {
        this.$message.warning(this.$t("myProjects.delTopic"));
      } else {
        this.$confirm(this.$t("myProjects.recover_confirm")).then((res) => {
          if (val) {
            const projectIdList = val.map((item) => item.projectId);
            if (projectIdList) {
              batchDeleteProject(projectIdList, 0).then(async (res) => {
                if (res.data.code === 200) {
                  this.$message.success(this.$t("myProjects.RecoverSuccessMsg"));
                  await this.getProjects_deleted();
                } else {
                  this.$message.error(this.$t("myProjects.RecoverFailedMsg"));
                }
              });
              that.$refs.projectTable_deleted.clearSelection();
            }
          }
        });
      }
    },
    handleRecove(val) {
      this.$confirm(this.$t("myProjects.recover_confirm")).then((res) => {
        const projectIdList = [val];
        batchDeleteProject(projectIdList, 0).then(async (res) => {
          if (res.data.code === 200) {
            this.$message.success(this.$t("myProjects.RecoverSuccessMsg"));
            await this.getProjects_deleted();
          } else {
            this.$message.error(this.$t("myProjects.RecoverFailedMsg"));
          }
        });
        that.$refs.projectTable_deleted.clearSelection();
      });
    },
    handleDelete_1(val) {
      this.$confirm(this.$t("myProjects.del_confirm")).then((res) => {
        const projectIdList = [val];
        batchDeleteProject_1(projectIdList).then(async (res) => {
          if (res.data.code === 200) {
            this.$message.success(this.$t("myProjects.delSuccessMsg"));
            await this.getProjects_deleted();
          } else {
            this.$message.error(this.$t("myProjects.delFailedMsg"));
          }
        });
        that.$refs.projectTable_deleted.clearSelection();
      });
    },
    // 批量删除项目
    batchDelete_1() {
      var that = this;
      var val = this.projects_deleted.tableChecked;
      if (val.length == 0) {
        this.$message.warning(this.$t("myProjects.delTopic"));
      } else {
        this.$confirm("确定要删除选择的项目?").then((res) => {
          if (val) {
            const projectIdList = val.map((item) => item.projectId);
            if (projectIdList) {
              batchDeleteProject_1(projectIdList).then(async (res) => {
                if (res.data.code === 200) {
                  this.$message.success(this.$t("myProjects.delSuccessMsg"));
                  await this.getProjects();
                } else {
                  this.$message.error(this.$t("myProjects.delSuccessMsg"));
                }
              });
              that.$refs.projectTable.clearSelection();
            }
            // console.log('选中的项目id列表：', projectIdList)
            // val.forEach((item, index) => {
            //   that.project_list.forEach((itemI, indexI) => {
            //     if (item === itemI) {
            //       that.project_list.splice(indexI, 1);
            //       batchDeleteProject(itemI.projectId);
            //     }
            //   });
            // });
          }
        });
      }
      // this.$refs.projectTable.clearSelection();
      // this.getProjects();
    },
    //查看项目详细内容
    checkDetail(row, event) {
      if (event.type == "selection") return;
      this.$store.commit("SET_PROJECTID", row.projectId);
      this.$router.push({
        path: "/project/detail",
        query: { id: row.projectId },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.children?.length > 0) {
        return "blue-row";
      } else {
        return "";
      }
    },

    toggleAllExpansion() {
      this.isExpanded = !this.isExpanded;
      this.project_list.forEach((row) => {
        this.$refs.projectTable.toggleRowExpansion(row, this.isExpanded);
      });
    },

    getModelProgress(fullRate) {
      if (fullRate == -1) {
        return { text: this.$t("myProjects.modelProgress3"), type: "danger" };
      } else if (fullRate == 0) {
        return { text: this.$t("myProjects.modelProgress0"), type: "info" };
      } else if (fullRate == 100) {
        return { text: this.$t("myProjects.modelProgress2"), type: "success" };
      } else {
        return { text: this.$t("myProjects.modelProgress1"), type: "primary" };
      }
    },
  },

  beforeDestroy() {
    if (this.processListener) {
      clearInterval(this.processListener);
      this.processListener = null;
    }
    if (
      this.projects_deleted &&
      this.projects_deleted.processListener &&
      typeof this.projects_deleted.processListener === "number"
    ) {
      clearInterval(this.projects_deleted.processListener);
      this.projects_deleted.processListener = null;
    }
  },
};
</script>
<style>
.panel-body .el-button {
  margin-left: 0px;
}
.panel-body .project-table .cell {
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  color: #333333;
}

/* 进度条 */
.panel-body .projtable .el-progress-bar__outer {
  height: 20px !important;
  border-radius: 4px;
  background-color: #f5f5f5;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.panel-body .projtable .el-progress-bar__inner {
  border-radius: 4px;
  min-width: 22px;
  text-align: center;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  transition: width 0.6s ease;
}
.panel-body .el-table__row {
  cursor: pointer;
}
.panel-body .el-table .blue-row {
  background: #f2f7ff;
}

.project-table .el-icon-arrow-right {
  font-size: 18px;
}
.project-table .el-table__placeholder {
  width: 0;
}
</style>
<style scoped>
.box-card {
  width: 100%;
  background-color: #f9f9f9;
  min-height: 540px;
  margin: auto;
}
.box-card .head-title {
  text-align: left;
  font-size: 20px;
}

.panel-body {
  text-align: left;
}

/* 按钮 */
.button-group {
  margin: 20px 0 20px 0px;
}
.button-group .btn1 {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0;
}

.button-group .btn2 {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.color1 {
  color: #3f8fd7;
}
.color2 {
  color: #75b469;
}
</style>
